import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Barco no Algarve · Iate Privado a partir de Vilamoura · Morningstar";
const DESC =
  "Charters privados de barco no Algarve a bordo do Morningstar — iate privado de 200 m² na Marina de Vilamoura, até 18 pessoas. Meio-dia, pôr-do-sol, Gruta de Benagil e dia completo.";
const PATH = "/pt/barco-algarve";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.algarveBoat;

export const Route = createFileRoute("/pt/barco-algarve")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: CONTENT.pt.eyebrow,
        title: "Charters de barco no Algarve a bordo do ",
        titleAccent: "Morningstar.",
        sub: "Um iate privado de 200 m² a partir da Marina de Vilamoura — totalmente tripulado e com catering, até 18 pessoas. Benagil, Marinha, pôr-do-sol em Vilamoura e Ria Formosa.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Pedir orçamento",
      }}
      pageContent={CONTENT.pt}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "barco no algarve, passeio de barco algarve, charter barco algarve, iate algarve, barco privado algarve",
      altPath: { en: "/algarve-boat", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Charters Privados de Barco no Algarve",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Barco no Algarve", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.pt.faqs)) },
      ],
    }),
});